import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
    over: ms === 0,
  };
}

export default function Countdown({ target, testId = 'countdown' }) {
  const { t } = useLang();
  const [v, setV] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => setV(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (v.over) return null;

  const units = [
    [v.d, t('countdown.d')],
    [v.h, t('countdown.h')],
    [v.m, t('countdown.m')],
    [v.s, t('countdown.s')],
  ];

  return (
    <div data-testid={testId} className="mt-5 rounded-lg border border-green-500/25 bg-green-500/5 px-4 py-3">
      <p className="flex items-center gap-1.5 text-[10px] font-semibold tracking-widest uppercase text-green-400">
        <Timer className="w-3.5 h-3.5" /> {t('countdown.label')}
      </p>
      <div className="mt-2 grid grid-cols-4 gap-2">
        {units.map(([n, l]) => (
          <div key={l} className="text-center">
            <span className="block font-display text-2xl text-white tabular-nums leading-none">{String(n).padStart(2, '0')}</span>
            <span className="mt-1 block text-[10px] uppercase tracking-wider text-slate-500">{l}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
